import React from 'react';
import PropTypes from 'prop-types';

import {GreyButton} from 'components/Button';
import Page from 'components/Page';
import DealMetrics from 'components/DealMetrics';

import './LeadDealSummary.css';

const LeadDealSummary = ({announce, deal}) => (
  <Page>
    <img styleName="picture" src={deal.image} alt="Flavourful" />
    <DealMetrics deal={deal} />
    <GreyButton
      onClick={() => { announce(); }}
      style={{margin: '0.5em 0'}}
      data-test="announce"
    >
      Send Announcement
    </GreyButton>
    <GreyButton
      onClick={() => {
        window.open(deal.memo.link);
      }}
      style={{margin: '0.5em 0'}}
      data-test="lead_memo"
    >
      View Investment Memo
    </GreyButton>
    <GreyButton
      onClick={() => {
        window.open(deal.model.link);
      }}
      style={{margin: '0.5em 0'}}
      data-test="lead_model"
    >
      View Financial Model
    </GreyButton>
  </Page>
);

LeadDealSummary.propTypes = {
  announce: PropTypes.func.isRequired,
  deal: PropTypes.shape({
    image: PropTypes.string.isRequired,
    memo: PropTypes.shape({
      link: PropTypes.string.isRequired,
    }).isRequired,
    model: PropTypes.shape({
      link: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default LeadDealSummary;



// WEBPACK FOOTER //
// ./web/flows/deal/lead/components/LeadDealSummary.js